import { defineStore } from 'pinia';
import { Ref, ref } from 'vue';
import { CommonTostId, Tost } from './types.ts';
import { TOST_CLOSE_DELAY } from './tools.ts';

// Цей store призначений для зберігання поточних активних (видимих) тостів.
// Це потрібно для того, щоб не показувати один і той же тост кілька разів одночасно

export const useTosterStore = defineStore('TosterStore', () => {
  const visibleTosts: Ref<Tost[]> = ref([]);

  const addTost = (input: Tost) => {
    const index = visibleTosts.value.findIndex((tost) => tost.id === input.id);

    if (index === -1) {
      visibleTosts.value.unshift({
        ...input,
        closeDelay: input.closeDelay || TOST_CLOSE_DELAY,
      });
    }
  };

  const removeTost = (id: CommonTostId | string) => {
    const index = visibleTosts.value.findIndex((tost) => tost.id === id);

    if (index !== -1) {
      visibleTosts.value.splice(index, 1);
    }
  };

  const clearTosts = () => {
    visibleTosts.value = [];
  };

  const isTostVisible = (id: CommonTostId | string) => {
    return visibleTosts.value.some((tost) => tost.id === id);
  };

  return {
    visibleTosts,

    addTost,
    removeTost,
    clearTosts,
    isTostVisible,
  };
});
